import React from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlus } from "@fortawesome/free-solid-svg-icons";

const Filters = (props) => {
  const {
    totalCount,
    // handleCreate
  } = props;

  return (
    <Card className="w-100 mb-2 rounded-0">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="m-0">
            Phone Codes
            {/* <button
              className="btn btn-success btn-sm ml-2"
              onClick={handleCreate}
              title="Create new phone code"
            >
              <FontAwesomeIcon icon={faPlus}/>
            </button> */}
          </h4>
          <div>
                        <span className="text-success mr-3" title="Total Count">
                            {totalCount}
                        </span>
          </div>
        </div>
      </Card.Header>
    </Card>
  );
};

Filters.propTypes = {
  handleCreate: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

export default Filters;



// WEBPACK FOOTER //
// ./src/views/pages/phone-codes/filters.js